// src/pages/FormularioA05Iniciales.jsx

import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { locale, addLocale } from 'primereact/api'
import FotoAnimal from './FotoAnimal';
import { obtenerAnimales,eliminarAnimal,guardarAnimal,datosGenerales,obtenerConsecutivo } from '../service/apiFormulario';
import SeleccionUsuariosDash from '../components/SeleccionUsuariosDash';
import SeleccionTipoDocumento from '../components/SeleccionTipoDocumento';
import SeleccionUsuario from '../components/SeleccionUsuario';
import SeleccionCodigos from '../components/SeleccionCodigos';
import SeleccionRegistraInicialMachos from '../components/SeleccionRegistraInicialMachos';
import SeleccionRegistraInicialMachosAdmin from '../components/SeleccionRegistraInicialMachosAdmin';
import SeleccionPedigreeInicial from '../components/SeleccionPedigreeInicial';
import SeleccionCodigoEspecie from '../components/SeleccionCodigoEspecie';
import SeleccionCodigoRaza from '../components/SeleccionCodigoRaza';
import SeleccionSexo from '../components/SeleccionSexo';
import SeleccionComposicionRacial from '../components/SeleccionComposicionRacial';
import SeleccionChipsLibres from '../components/SeleccionChipsLibres';
import FormulariosA05Detalles from '../components/FormulariosA05Detalles';

const FormularioA05Iniciales = () => {
       let emptyProduct = {
        TID_PROPIETARIO:'', 
        NID_PROPIETARIO:'',
        COMPOSICION:'',
        CONSECUTIVO:'',
        FECHA_SOLICITUD:'',
        CRIADERO:'',
        DIRECCION:'',
        DEPARTAMENTO:'',
        MUNICIPIO:'',
        ESPECIE:'',
        RAZA:'',
        SEXO:'',
        NOMBRE:'',
        FECHA_NACIMIENTO:'',
        MARCAS_HATO:'',
        RASGOS_PARTICULARES:'',
        COLOR:'',
        CHIP:'',
        PUNTAJE_FUNDADORES:'',
        PREFIJO:'',
        CONCEPCION:'',
        LIBRO:'',
        TID_REGISTRADOR:'',
        NID_REGISTRADOR:'',
        TID_REGISTRADOR1:'',
        NID_REGISTRADOR1:0,
        TID_REGISTRADOR2:'',
        NID_REGISTRADOR2:0,
        CHIP_PADRE:'',
        CHIP_ABUELO_PATERNO:'',
        CHIP_ABUELA_PATERNA:'',
        CHIP_MADRE:'',
        CHIP_ABUELO_MATERNO:'',
        CHIP_ABUELA_MATERNA:'',
        NOMPROPIETARIO:'',
        TIDPROPIETARIO:'',
        NOMANIMAL:'',
        TIDREGISTRADOR:'',
        TIDREGISTRADOR1:'',
        TIDREGISTRADOR2:'',
        NOMREGISTRADOR:'',
        NOMREGISTRADOR1:'',
        NOMREGISTRADOR2:'',
        FOTO:''
    };
    addLocale('es', {
            firstDayOfWeek: 1,
            dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
            dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
            dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            monthNames: ['Enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
            monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
            today: 'Hoy',
            clear: 'Limpiar'
        });
    
        locale('es');
  const toastRef = useRef(null);
  const dt = useRef(null);
      const [productDialog, setProductDialog] = useState(false);
      const [productDialogDetalle, setProductDialogDetalle] = useState(false);
      const [product, setProduct] = useState(emptyProduct);
      const [selectedProducts, setSelectedProducts] = useState(null);
      const [submitted, setSubmitted] = useState(false);
      const [globalFilter, setGlobalFilter] = useState(null);
      const [reloadUsuarios, setReloadUsuarios] = useState(true)
      const [usuariosAnco, setUsuariosAnco] = useState([])
      const [muestraCodigos, setMuestraCodigos] = useState(false)
      const [nidPropietario, setNidPropietario] = useState(0)
      const [fechaSolicitud, setFechaSolicitud] = useState('')
      const [fechaNacimiento, setFechaNacimiento] = useState('')
      const [muestraRaza, setMuestraRaza] = useState(false)
      const [muestraParentesco, setMuestraParentesco] = useState(false)
      const [enviar, setEnviar] = useState(false)
      const [reloadDatosConsecutivo, setReloadDatosConsecutivo] = useState(false)
      const [mdatosConsecutivo, setMdatosConsecutivo] = useState([])
      const [editProductDialog, setEditProductDialog] = useState(false)
      const [consecutivo, setConsecutivo] = useState(0)
      const [tidPropietario, setTidPropietario] = useState('')
      const [muestraUsuario, setMuestraUsuario] = useState(false)
      const [fundadorMacho, setFundadorMacho] = useState(false)
      const [fundadorHembra, setFundadorHembra] = useState(false)
      const [puroPedigree, setPuroPedigree] = useState(false)
      const [deleteProductsDialog, setDeleteProductsDialog] = useState(false)
      const [reloadDatosIniciales, setReloadDatosIniciales] = useState([])
      const [value1, setValue1] = useState(true)
      const interval = useRef(null);
      const [ayuda, setAyuda] = useState(false)
      const [muestra, setMuestra] = useState(false)
      const [codigoEspecie, setCodigoEspecie] = useState('')
      const [sexo, setSexo] = useState(false)
      const [tipoSexo, setTipoSexo] = useState(false)
      const [composicion, setComposicion] = useState(false)
      const [puntaje, setPuntaje] = useState(0)
      const [composicionAnimal, setComposicionAnimal] = useState('')
      const [productos, setProductos] = useState('')
      const [visible, setVisible] = useState('')
    const [administrador, setAdministrador] = useState(localStorage.getItem('administrador'))

   const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
        setMuestraCodigos(false);
        setMuestraParentesco(false)
    }

    const hideDialogDetalle = () => {
        setSubmitted(false);
        setProductDialogDetalle(false);
    }
  useEffect(() => {
    if (reloadUsuarios) {
      const recarga = async () => {
        setReloadUsuarios(false);
        const resultado = await obtenerAnimales(nidPropietario, muestra, toastRef);
        if (Array.isArray(resultado) && resultado.length > 0) {
          setProductos(resultado);
          console.log(resultado)
          if (!muestra) setMuestra(true);
        }
      };
      recarga();
    }
  }, [reloadUsuarios]);

  useEffect(() => {
          if (reloadDatosIniciales) { 
                const recarga1 = async () => {
                setReloadUsuarios(false);
                const resultado = await datosGenerales(nidPropietario, muestra, toastRef);
                if (Array.isArray(resultado) && resultado.length > 0) {
                    setMdatosConsecutivo(resultado);
                }
            };
            recarga1();
          }
    }, [reloadDatosIniciales, nidPropietario])

  const handleDelete = (rowData) => {
  toastRef.current.show({
    severity: 'warn',
    summary: '¿Deseas eliminar este registro?',
    detail: (
      <div>
        <p>Consecutivo: <strong>{rowData.CONSECUTIVO}</strong></p>
        <div className="flex gap-2 mt-2">
          <Button
            label="Eliminar"
            icon="pi pi-trash"
            className="p-button-danger p-button-sm"
            onClick={async () => {
              toastRef.current.clear(); // Oculta la confirmación
              const resultado = await eliminarAnimal(rowData.CONSECUTIVO,rowData.CHIP,rowData.NID_PROPIETARIO,'A05');
              if (resultado == 1) {
                // const data = await obtenerAnimales(nidPropietario, muestra, toastRef);
                // setProductos(data);
                setReloadUsuarios(true);
                toastRef.current.show({
                  severity: 'success',
                  summary: 'Eliminado',
                  detail: 'El registro ha sido eliminado ✅',
                  life: 3000
                });
              } else {
                toastRef.current.show({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No se pudo eliminar el registro ❌',
                  life: 4000
                });
              }
            }}
          />
          <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button-secondary p-button-sm"
            onClick={() => toastRef.current.clear()}
          />
        </div>
      </div>
    ),
    life: 10000, // tiempo suficiente para que el usuario elija
    sticky: true // mantiene el toastRef visible hasta que se cierre o se tome acción
  });
};

const handleGuardar = async () => {
  const resultado = await guardarAnimal(product,mdatosConsecutivo,toastRef, puntaje);
//console.log("kjasdkjdaskjdsa asdkjasdkkads "+resultado)
  if (resultado == 1) {
    toastRef.current.show({
      severity: 'success',
      summary: 'Éxito',
      detail: 'Registro guardado correctamente ✅',
      life: 3000
    });
    hideDialog();
    setReloadUsuarios(true);
  } 
};

const handleModificar = async (product) => {
  const resultado = await obtenerConsecutivo(product.NID_PROPIETARIO,product.CONSECUTIVO);
  if (Array.isArray(resultado) && resultado.length > 0) {
    console.log(resultado)
        setProduct(resultado[0]);
         const resultado1 = await datosGenerales(resultado[0].NID_PROPIETARIO, muestra, toastRef);
                if (Array.isArray(resultado1) && resultado1.length > 0) {
                    setMdatosConsecutivo(resultado1);
                }
        setProductDialog(true);
        setEnviar(true)
          if (!muestra) setMuestra(true);
        }
  } 


      const handleplanta = async(dato,opc) =>{
         console.log("ramiro celis" + dato)
        if(dato==undefined) return
        console.log(dato+" "+opc)
        if(opc==1){
           setNidPropietario(dato)
           product.NID_PROPIETARIO=dato
           setReloadDatosIniciales(true)
        }else if(opc==2){   
           product.CONSECUTIVO=dato
           setConsecutivo(dato)
        }else if(opc==3){
            setCodigoEspecie(dato)
            product.ESPECIE=dato
         }else if(opc==4){
            product.RAZA=dato
         }else if(opc==12){
            product.SEXO=dato
            setTipoSexo(dato)
            setSexo(true)
        }else if(opc==9){
          setTidPropietario(dato)
          product.TID_PROPIETARIO=dato
        }
        else if(opc==10){
            product.TID_REGISTRADOR=dato
        }else if(opc==11){
             product.TID_REGISTRADOR1=dato
        }else if(opc==13){
            product.TID_REGISTRADOR2=dato
       }else if(opc==14){
            product.NID_REGISTRADOR=dato
       }else if(opc==15){
            product.NID_REGISTRADOR1=dato
        }else if(opc==16){
            product.NID_REGISTRADOR2=dato
        }else if(opc==100){
            product.CHIP=dato
        }else if(opc==150){
            setNidPropietario(dato)
            setReloadUsuarios(true)
        }else if(opc==200){
            product.COMPOSICION=dato
            setComposicionAnimal(dato)
            if(dato=='FU'){
                setComposicion(true)
            }else{
                setComposicion(false)
            }
        }

        if(composicion && sexo){
            if(sexo){
                if(product.SEXO=='M'){
                    setPuntaje(79)
                    setFundadorMacho(true)
                    setFundadorHembra(false)
                    setPuroPedigree(false)
                }else{
                    setPuntaje(70)
                    setFundadorMacho(false)
                    setFundadorHembra(true)
                    setPuroPedigree(false)
                }
            }
        }else if(product.COMPOSICION!='FU' && product.COMPOSICION!='' && !composicion){
            setFundadorMacho(false)
            setFundadorHembra(false)
            setPuroPedigree(true)
        }


    }
      const productDialogFooter = (
           
            <>
                <Button label={enviar ? "Cancelar" : "Cerrar"} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                {enviar &&
                    <Button label="Enviar" icon="pi pi-check" className="p-button-text" onClick={handleGuardar} />
                }
    
            </>
    );
   const actionBodyTemplate = (rowData) => {
  return (
    <>
      <Button
        icon="pi pi-pencil"
        className="p-button-rounded p-button-info mr-2"
        tooltip="Modificar registro"
        onClick={() => handleModificar(rowData)}
      />
      <Button
        icon="pi pi-trash"
        className="p-button-rounded p-button-danger mr-2"
        tooltip="Eliminar registro"
        onClick={() => handleDelete(rowData)}
      />
      {/* <Button
        icon="pi pi-file-pdf"
        className="p-button-rounded p-button-warning"
        tooltip="Ver certificado"
        onClick={() => handleVerCertificado(rowData)}
      /> */}
    </>
  );
};


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || '';
    setProduct({ ...product, [name]: val });
  };

  const header = (
    <div className="table-header">
      <h5 className="mb-0">Gestión de Animales Iniciales</h5>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
      </span>
    </div>
  );

   const openNew = () => {
        setMdatosConsecutivo([])
        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(false);
        setMuestraCodigos(false)
        setMuestraRaza(false)
        setMuestraUsuario(false)
        setMuestraParentesco(false)
        setProductDialog(true);
        setEnviar(true)
    }

   
    
     function calcularEdad(fecha, opcion) {
        if (opcion == 1) {
            product.FECHA_SOLICITUD = new Date(fecha).toISOString().slice(0, 10)
        }else{
            product.FECHA_NACIMIENTO = new Date(fecha).toISOString().slice(0, 10)
        }
    }

     

  return (
    <div className="p-4">
      <Toast ref={toastRef} position="top-right" />
     

      <Button label="Nuevo Registro" icon="pi pi-plus" onClick={() => { setProduct({}); setVisible(openNew); }} className="mb-3" />

      <DataTable
        ref={dt}
        value={productos}
        selection={selectedProducts}
        onSelectionChange={(e) => setSelectedProducts(e.value)}
        dataKey="CONSECUTIVO"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25]}
        className="datatable-responsive"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        globalFilter={globalFilter}
        emptyMessage="No existen registros."
        header={header}
        responsiveLayout="scroll"
      >
        <Column body={actionBodyTemplate} header="Acciones" style={{ width: '150px' }} />
        <Column
          field="FOTO"
          header="FOTO"
          body={(productos) => (
            <img
              src={
                productos.FOTO && productos.FOTO.startsWith('https')
                  ? productos.FOTO
                  : 'https://www.ancogenecop.com/APIANCO/documentos/sin-foto.jpg'
              }
              alt="Foto del animal"
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://www.ancogenecop.com/APIANCO/documentos/sinFoto.png';
              }}
            />
          )}
        />
        <Column field="TIDPROPIETARIO" header="TID_PROPIETARIO" sortable />
        <Column field="NID_PROPIETARIO" header="NID_PROPIETARIO" sortable />
        <Column field="NOMPROPIETARIO" header="PROPIETARIO" sortable />
        <Column field="CONSECUTIVO" header="CONSECUTIVO" sortable />
        <Column field="CHIP" header="CHIP" sortable />
        <Column field="FECHA_SOLICITUD" header="FECHA_SOLICITUD" sortable />
        <Column field="FECHA_NACIMIENTO" header="FECHA_NACIMIENTO" sortable />
        <Column field="CHIP_PADRE" header="CHIP_MACHO" sortable />
        <Column field="CHIP_MADRE" header="CHIP_HEMBRA" sortable />
        <Column field="NOMESPECIE" header="ESPECIE" sortable />
        <Column field="SEXO" header="SEXO" sortable />
        <Column field="RAZA" header="RAZA" sortable />
        <Column field="COLOR" header="COLOR" sortable />
        <Column field="NOMANIMAL" header="NOMBRE ANIMAL" sortable />
        <Column field="PREFIJO" header="PREFIJO" sortable />
        <Column field="MARCAR_HATO" header="MARCAR_HATO" sortable />
        <Column field="RASGOS_PARTICULARES" header="RASGOS_PARTICULARES" sortable />
        <Column field="PUNTAJE_FUNDADORES" header="PUNTAJE_FUNDADORES" sortable />
        <Column
          field="FOTO"
          header="FOTO"
          body={(productos) => (
            <img
              src={
                productos.FOTO && productos.FOTO.startsWith('https')
                  ? productos.FOTO
                  : 'https://www.ancogenecop.com/APIANCO/documentos/sin-foto.jpg'
              }
              alt="Foto del animal"
              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '8px' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://www.ancogenecop.com/APIANCO/documentos/sinFoto.png';
              }}
            />
          )}
        />

        <Column body={actionBodyTemplate} header="Acciones" style={{ width: '150px' }} />
      </DataTable>

      <Dialog visible={productDialogDetalle} style={{ width: '950px' }} modal className="p-fluid" onHide={() => setProductDialogDetalle(false)}>
        <FormulariosA05Detalles nidPropietario={nidPropietario} consecutivo={consecutivo} />
      </Dialog>

          <Dialog visible={productDialog} style={{ width: '900px' }} header={enviar ? "Adicionar Animal Inicial" : "Modificar Animal Inicial"} modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        {/* {product.image && <img src={`assets/demo/images/product/${product.image}`} alt={product.image} width="150" className="mt-0 mx-auto mb-5 block shadow-2" />} */}
                        <div className="formgrid grid">
                        <div className="field col">
                                <label htmlFor="name">Tipo Documento</label>
                                <SeleccionTipoDocumento handleplanta={handleplanta} opcion={9} TIDPROPIETARIO={product.TID_PROPIETARIO}
                                required/>
                            </div>
                            {/* {muestraUsuario && */}
                        <div className="field col">
                                <label htmlFor="name">Propietario</label>
                                <SeleccionUsuario codigo={'A05'} handleplanta={handleplanta} NOMPROPIETARIO={product.NID_PROPIETARIO}
                                 required
                                 tidPropietario={tidPropietario}
                                />
                            </div>
                        {/* } */}
                                <div className="field col">
                                <label htmlFor="name">Consecutivo</label>
                                    <SeleccionCodigos NID_PROPIETARIO={nidPropietario} 
                                    codigo={'A05'} CONSECUTIVO={product.CONSECUTIVO} handleplanta={handleplanta}
                                    required
                                    />
                                </div>
                        </div>
                        <hr />
                            <>
                        <div className="formgrid grid">
                        {/* {muestraParentesco && */}
                        <>
                                <DataTable ref={dt} value={mdatosConsecutivo}
                                    dataKey="id"  className="datatable-responsive"
                                     responsiveLayout="scroll">
                                    <Column field="CRIADERO" header="CRIADERO" sortable ></Column>
                                    <Column field="DIRECCION" header="DIRECCION" sortable ></Column>
                                    <Column field="DEPARTAMENTOD" header="DEPARTAMENTO" sortable ></Column>
                                    <Column field="MUNICIPIOD" header="MUNICIPIO" sortable ></Column>
                                    <Column field="PREFIJO" header="PREFIJO" sortable ></Column>
                                    <Column field="NOMCONCEPCION" header="FORMA DE CONCEPCION" sortable ></Column>
                                    <Column field="LIBRO" header="LIBRO" sortable ></Column>
                                </DataTable>
                                <hr/>
                        </>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="name">Especie</label>
                                <SeleccionCodigoEspecie handleplanta={handleplanta} COD_ESPECIE={product.ESPECIE}/>
                            </div>
                            <div className="field col">
                                <label htmlFor="name">Raza</label>
                                    <SeleccionCodigoRaza COD_ESPECIE={codigoEspecie} RAZA={product.RAZA}
                                    NID_PROPIETARIO={nidPropietario}
                                    handleplanta={handleplanta}/>
                                </div>
                                <div className="field col col">
                                    <label htmlFor="name">Sexo</label>
                                    <SeleccionSexo handleplanta={handleplanta} SEXO={product.SEXO}
                                    required
                                    />
                                </div>
                                <div className="field col col">
                                    <label htmlFor="name">Composición Racial</label>
                                    <SeleccionComposicionRacial handleplanta={handleplanta} COMPOSICION={product.COMPOSICION}
                                    required
                                    />
                                </div>

                            </div>

                                <div className="formgrid grid">
                                    <div className="field col-3">
                                        <label htmlFor="dirección">Fecha de Solicitud: {product.FECHA_SOLICITUD}</label>
                                        <Calendar showIcon showButtonBar value={fechaSolicitud}
                                            dateFormat="yy-mm-dd" monthNavigator={true} yearNavigator={true}
                                            yearRange="1960:2060" required
                                            readOnlyInput={true}
                                            locale='es'
                                            onChange={(e) => calcularEdad(e.value, 1)}></Calendar>
                                    </div>
                                    <div className="field col-3">
                                        <label htmlFor="description">Nombre</label>
                                        <InputText id="nombre" value={product.NOMBRE} onChange={(e) => onInputChange(e, 'NOMBRE')} />
                                        </div>
                                        <div className="field col-3">
                                        <label htmlFor="description">Color</label>
                                        <InputText id="color" value={product.COLOR} onChange={(e) => onInputChange(e, 'COLOR')} />
                                        </div>
                                        <div className="field col-3">
                                        <label htmlFor="description">Chip Asignado</label>
                                        <SeleccionChipsLibres handleplanta={handleplanta} CHIP={product.CHIP}
                                        reuired
                                        />
                                        </div>
                                 </div>
                                 <div className="formgrid grid">
                                 <div className="field col-3">
                                        <label htmlFor="dirección">Fecha de Nacimiento: {product.FECHA_NACIMIENTO}</label>
                                        <Calendar showIcon showButtonBar value={fechaNacimiento}
                                            dateFormat="yy-mm-dd" monthNavigator={true} yearNavigator={true}
                                            yearRange="1960:2060" required
                                            readOnlyInput={true}
                                            locale='es'
                                            onChange={(e) => calcularEdad(e.value, 2)}></Calendar>
                                    </div>
                                 <div className="field col-3">
                                        <label htmlFor="description">Marcas de Hato</label>
                                        <InputText id="marcas" value={product.MARCAS_HATO} onChange={(e) => onInputChange(e, 'MARCAS_HATO')} />
                                    </div>

                                    <div className="field col-3">
                                        <label htmlFor="description">Rasgos Particulares</label>
                                        <InputText id="rasgos" value={product.RASGOS_PARTICULARES} onChange={(e) => onInputChange(e, 'RASGOS_PARTICULARES')} />
                                     </div>
                                     {composicionAnimal=='FU' &&
                                     <div className="field col-38">
                                        <label htmlFor="description">Puntaje Fundadores</label>
                                        <InputText id="puntaje" value={product.PUNTAJE_FUNDADORES} onChange={(e) => onInputChange(e, 'PUNTAJE_FUNDADORES')} />
                                     </div>
                                     
                                     }

                                </div>
                                <hr/> 
                                {composicion && sexo &&
                                <>
                                    {tipoSexo=='M' ?
                                    <>
                                      {administrador==0 ?
                                       <SeleccionRegistraInicialMachos handleplanta={handleplanta} 
                                       product={product} submitted={submitted} 
                                       TIDREGISTRADOR={product.TIDREGISTRADOR}
                                       TIDREGISTRADOR1={product.TIDREGISTRADOR1}
                                       TIDREGISTRADOR2={product.TIDREGISTRADOR2}
                                       NOMREGISTRADOR={product.NOMREGISTRADOR}
                                       NOMREGISTRADOR1={product.NOMREGISTRADOR1}
                                       NOMREGISTRADOR2={product.NOMREGISTRADOR2}
                                       tipoSexo={tipoSexo}/>
                                      :<SeleccionRegistraInicialMachosAdmin handleplanta={handleplanta} 
                                      product={product} submitted={submitted} 
                                      TIDREGISTRADOR={product.TIDREGISTRADOR}
                                       TIDREGISTRADOR1={product.TIDREGISTRADOR1}
                                       TIDREGISTRADOR2={product.TIDREGISTRADOR2}
                                       NOMREGISTRADOR={product.NOMREGISTRADOR}
                                       NOMREGISTRADOR1={product.NOMREGISTRADOR1}
                                       NOMREGISTRADOR2={product.NOMREGISTRADOR2}
                                      tipoSexo={tipoSexo}/>
                                      }
                                    </>    
                                    :
                                    <>
                                      {administrador==1 &&
                                       <SeleccionRegistraInicialMachosAdmin handleplanta={handleplanta} 
                                      product={product} submitted={submitted} 
                                      TIDREGISTRADOR={product.TIDREGISTRADOR}
                                       TIDREGISTRADOR1={product.TIDREGISTRADOR1}
                                       TIDREGISTRADOR2={product.TIDREGISTRADOR2}
                                       NOMREGISTRADOR={product.NOMREGISTRADOR}
                                       NOMREGISTRADOR1={product.NOMREGISTRADOR1}
                                       NOMREGISTRADOR2={product.NOMREGISTRADOR2}
                                      tipoSexo={tipoSexo}/>
                                      }
                                    </>
                                    }
                                </>
                                }
                                {!composicion && tipoSexo!='' &&
                                    <SeleccionPedigreeInicial product={product} submitted={submitted}/>
                                }
                                <FotoAnimal product={product}/>
                                <div className="field col-3">
                              <label htmlFor="foto">Foto del Animal</label>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    setProduct({ ...product, FOTO: file });
                                  }
                                }}
                              />
                            </div>
                            </>
                    </Dialog>
    </div>
  );
};

export default FormularioA05Iniciales;
